// extracted by mini-css-extract-plugin
export default {"servicesIcon":"servicePage_servicesIcon__L5dM2","servicesText":"servicePage_servicesText__9lBot","subtitle":"servicePage_subtitle__BlPa6"};